import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/auth.service';
import { NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_ACCENT_500, COLOR_PRIMARY_CONTRAST_500 } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-toolbar-mobile-menu',
  templateUrl: './toolbar-mobile-menu.component.html',
  styleUrls: ['./toolbar-mobile-menu.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
    ]),
  ],
})
export class ToolbarMobileMenuComponent {
  @Input() current_nav_item?: NavigationItem;
  nav_items: Map<string, NavigationItem>;
  is_menu_visible: boolean = false;

  constructor(
    private navigation_service: NavigationService,
    private auth_service: AuthService,
    private utils_service: UtilsService,
    private meta: Meta,
  ) {
    this.nav_items = this.navigation_service.navigation_set.nav_items;
  }

  onMenuToggle(): void {
    this.is_menu_visible = !this.is_menu_visible;
    if (this.is_menu_visible) {
      this.meta.updateTag({ content: COLOR_ACCENT_500 }, 'name=theme-color');
    }
    if (!this.is_menu_visible) {
      this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
    }
  }

  onNavItemClick(item: NavigationItem): void {
    if (item.path) this.navigation_service.toGenericPath(item.path);
  }

  onMenuItemClick(item: NavigationItem): void {
    if (item.path) this.navigation_service.toGenericPath(item.path);
  }

  getNavItems(): NavigationItem[] {
    return [...this.nav_items.values()];
  }

  onLogoutClick(): void {
    this.auth_service.signout().subscribe();
  }

  getCurrentItemClass(nav_item: NavigationItem): { [hey: string]: boolean } {
    return {
      'sp-toolbar-mobile-menu__selected-item': nav_item.label == this.current_nav_item?.label,
      'sp-color__accent-contrast': nav_item.label != this.current_nav_item?.label,
    };
  }

  getProfileEmail(): string {
    return this.utils_service.getProfileEmail();
  }
}
